/* TODO this file will be broken down into smaller files */

import { CompensationBaseBonus } from './core/compensation-base-bonus.model';
import { RootConfig, TemplateConfig } from './core/config.scorecard.model';
import { PerformanceClassDto } from './core/performance-class-dto.model';
import { RosterItemDto } from './core/roster-item.model';
import { TrendType } from './core/trend-type.model';
import { DescriptionType } from './scorecard-data/description-type.model';
import { DirectReportContributionResult } from './widgets/grid/direct-report-contribution-grid.model';
import { DirectReportRankResult } from './widgets/grid/direct-report-rank-grid.model';
import { DirectReportScorecardResult } from './widgets/grid/direct-report-scorecard-grid.model';
export interface PillarAndMetricResult {
    scorecardId?: number;
    pillarId?: number;
    metricId?: number;
    metricInitials?: string;
    metricShortName?: string;
    metricName?: string;
    rankOrder?: boolean; // LOWER_IS_BETTER = false, HIGHER_IS_BETTER = true
    actual?: number;
    actualPrev?: number;
    target?: number;
    targetPercent?: number;
    targetPercentPrev?: number;
    weight?: number;
    originalPoints?: number;
    adjustedPoints?: number;
    metricScore?: number;
    pointsBand?: string;
    bandName?: string;
    nTile?: number;
    nTileBand?: string;
    actualType?: string;
    targetType?: string;
    percentType?: string;
    scoreType?: string;
    targetThresholdId?: number;
    targetThresholdColour?: string;
    actualTrend?: number;
    targetPercentTrend?: number;
    metricRankSg?: string;
    metricRankSiteSg?: string;
    actualTrendThresholdId?: number;
    actualTrendThresholdColour?: string;
    actualTrendThresholdName?: string;
    targetPercentTrendThresholdId?: number;
    targetPercentTrendThresholdColour?: string;
    targetPercentTrendThresholdName?: string;
    coachingPlanActive?: boolean;
}

export interface GridData {
    tplConfig: TemplateConfig;
    header: ScorecardDto;
    data: PillarAndMetricResult[];
    attributes: ScorecardAttributes[];
    directReportContributionGrid?: DirectReportContributionResult[];
    directReportRankGrid?: DirectReportRankResult[];
}

export interface FyiMetricDto {
    scorecardId: number;
    metricId: number;
    metricName: string;
    actual: number;
    target: number;
    targetPercentage: number;
    actualTrend: number;
    rankOrder: boolean; // LOWER_IS_BETTER = false, HIGHER_IS_BETTER = true
    isCoachingPlanActive: boolean;
}

export interface FyiMetric extends FyiMetricDto {
    actualTrendColor?: string;
}

export interface OverallScore {
    scorecardId: number;
    scoreSeq: number;
    scoreText: string;
    scoreValue?: number;
    descriptionTypeId?: DescriptionType;
}

export interface Rank {
    scorecardId: number;
    rankTypeId: number;
    rankName: string;
    rankResultScorecardPeriod: string;
    totalPositionsScorecardPeriod: string;
}

export interface Compensation {
    descriptionTypeId: number;
    targetTypeId?: number;
    targetId?: number;
    operation?: number;
    sourceTypeId?: number;
    sourceId?: number;
    conditionValue?: number;
    lowerRange: string;
    upperRange: string;
    effectValue?: number;
    value?: number;
    effectType?: number;
    inEffect?: boolean;
}

export interface CompensationConditionDto extends Compensation {
    scorecardId: number;
    conditionId: number;
    description: string;
    value?: number;
    effectType: EffectTypes;
    inEffect: boolean;
}

export interface CompensationCondition extends CompensationConditionDto {
    isPositive?: boolean;
}

export interface CompensationQualifier extends Compensation {
    scorecardId: number;
    qualifierId: number;
    description: string;
    value?: number;
    isPercentage: boolean;
    qualifierMet: boolean;
    isQualificationCondition: boolean;
}

export interface CompensationModifierDto extends Compensation {
    scorecardId: number;
    modifierId: number;
    description: string;
    value?: number;
    effectType: EffectTypes;
    inEffect: boolean;
}

export interface CompensationModifier extends CompensationModifierDto {
    isPositive?: boolean;
}

export interface CompensationBonus {
    scorecardId: number;
    bonusId: number;
    bonusBaseAmount?: number;
    bonusModifier?: number;
    bonusAmount?: number;
    operation?: string;
}

export interface ScorecardAttributes {
    attributeName: string;
    attributeValue: string;
    scorecardId?: number;
}

/// ///////

// Scorecard.Lookup_PeriodType
export enum PeriodType {
    MONTHLY = 1,
    YTD,
    YTD_OVERLAPPING,
    QTD,
}

export enum EffectTypes {
    CAP = 0,
    BOOST_Pct,
    REDUCE_Pct,
    REDUCE_Pts,
    BOOST_Pts,
    BOOST_$ = 6,
    REDUCE_$,
}

export enum RankTypes {
    SUPER_GROUP_OVERALL = 1,
    SITE_SUPERGROUP,
    PILLAR,
    METRIC,
    ROLE_OVERALL,
    CUSTOM,
    BUDGET_COMPENSATION,
    ROLE_PILLAR = 9,
    ROLE_BY_REGION,
    ROLE_BY_PILLAR_REGION,
    CUSTOM_AREA_MGR,
    CUSTOM_AREA_MGR_PILLAR,
    SUPERGROUP_WITH_COMPENSATION,
    PEER_GROUP_OVERALL,
    LOB_OVERALL,
}

export interface PeriodTypeShallow {
    periodTypeId: PeriodType;
    periodTypeName: string;
    periodTypeOrder: number;
}

export interface RankHistoryDto {
    rankTypeId?: number;
    rankTypeName?: string;
    myRank?: number;
    maxRank?: number;
}

export interface ScorecardDto {
    scorecardId?: number;
    managerId?: number;
    managerName?: string;
    userId?: number;
    definitionVersionId: string;
    periodType?: PeriodType;
    periodTypeName?: string;
    groupId?: number;
    groupName?: string;
    groupShortName?: string;
    groupInitials?: string;
    startDate?: Date;
    endDate?: Date;
    adjustedPoints?: number;
    numberOfDays?: number;
    siteId?: number;
    siteName?: string;
    siteShortName?: string;
    siteInitials?: string;
    published?: boolean;
    generatedOn?: Date;
    trendId?: TrendType;
    prevAdjustedPoints?: number;
    ranks?: RankHistoryDto[];
    performanceClass?: PerformanceClassDto;
    previousPerformanceClass?: PerformanceClassDto;
}

export interface ScorecardDataDto {
    scorecardId: number;
    templateConfig: TemplateConfig;
    widgetTemplateConfig: TemplateConfig;
    pillarsAndMetrics: PillarAndMetricResult[];
    fyiMetrics: FyiMetric[];
    overallScores: OverallScore[];
    ranks: Rank[];
    roster: RosterItemDto[];
    compensationConditions: CompensationCondition[];
    compensationModifiers: CompensationModifier[];
    compensationQualifiers: CompensationQualifier[];
    compensationBonus: CompensationBonus;
    compensationBaseBonus: CompensationBaseBonus[];
    scorecardAttributes: ScorecardAttributes[];
    directReportContributionMetrics: DirectReportContributionResult[];
    directReportScorecardsRank: DirectReportRankResult[];
    directReportScorecardsMetrics: DirectReportScorecardResult[];
}

// TODO revise. maybe have a shallow version of this and api call so that rootConfig and periodTypes need not be repeated for subsequent periodType calls
// TODO revise. rootConfig is repeated for all box calls. maybe have api optionally return it
export interface ScorecardBoxDto {
    rootConfig: RootConfig;
    periodTypes: PeriodTypeShallow[];
    scorecardHistory: ScorecardDto[];
    initialScorecard: ScorecardDto;
    initialScorecardData: ScorecardDataDto;
}

export const createEmpty = (): ScorecardDto => ({
    definitionVersionId: null,
});

export const createEmptyData = (): ScorecardDataDto => ({
    scorecardId: null,
    templateConfig: {} as any as TemplateConfig, // TODO create empty fn
    widgetTemplateConfig: {} as any as TemplateConfig, // TODO create empty fn
    pillarsAndMetrics: null,
    fyiMetrics: null,
    overallScores: null,
    ranks: null,
    roster: null,
    compensationConditions: null,
    compensationModifiers: null,
    compensationQualifiers: null,
    compensationBonus: null,
    compensationBaseBonus: null,
    scorecardAttributes: null,
    directReportContributionMetrics: null,
    directReportScorecardsRank: null,
    directReportScorecardsMetrics: null,
});

export const createEmptyBox = (): ScorecardBoxDto => ({
    periodTypes: [],
    rootConfig: null,
    scorecardHistory: [],
    initialScorecard: createEmpty(),
    initialScorecardData: createEmptyData(),
});

export function datasetKey(
    periodType: PeriodType,
    scorecardId: number,
): string {
    return `${periodType}-${scorecardId}`;
}
